import React from "react";
import {BsCheck2Square} from "react-icons/bs";

const UserEMailAddressConfirmedSymbol: React.FC<{className?: string}> = ({className}) => (
    <span className={`text-success ${className ?? ""}`}><BsCheck2Square/></span>
);

export default UserEMailAddressConfirmedSymbol;